import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
    baseURL: `${BACKEND_URL}/api`,
    withCredentials: true,
    timeout: 60000,
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err.response?.status === 401) {
            // let callers handle
        }
        return Promise.reject(err);
    }
);

export function fileUrl(path) {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    if (path.startsWith("/api/")) return `${BACKEND_URL}${path}`;
    return `${BACKEND_URL}/api/files/${path}`;
}

export function formatApiError(detail) {
    if (detail == null) return "حدث خطأ ما، يرجى المحاولة مرة أخرى";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
    if (detail?.msg) return detail.msg;
    return String(detail);
}

export default api;
